var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intermediate_wrap" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.productFlag == 3
        ? _c("ul", { staticClass: "taxation_item" }, [
            _c(
              "li",
              [
                _c("img", {
                  staticClass: "app_logo",
                  attrs: { src: require("../img/ctx-logo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "app_bg",
                  attrs: { src: require("../img/ctx-bg.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [_vm._v("（中级1.0）")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.entrySys("ctx")
                      }
                    }
                  },
                  [_vm._v("进入系统")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("img", {
                  staticClass: "app_logo",
                  attrs: { src: require("../img/ptx-logo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "app_bg",
                  attrs: { src: require("../img/ptx-bg.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [_vm._v("（中级1.0）")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.entrySys("ptx")
                      }
                    }
                  },
                  [_vm._v("进入系统")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("img", {
                  staticClass: "app_logo",
                  attrs: { src: require("../img/jss-logo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "app_bg",
                  attrs: { src: require("../img/jss-bg.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [_vm._v("（中级1.0）")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.entrySys("jss")
                      }
                    }
                  },
                  [_vm._v("进入系统")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("img", {
                  staticClass: "app_logo",
                  attrs: { src: require("../img/gxl-logo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "app_bg",
                  attrs: { src: require("../img/ctx-bg.png"), alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.entrySys("gxl")
                      }
                    }
                  },
                  [_vm._v("进入系统")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.centerDialogVisible,
            width: "400px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "cont" }, [
            _c("p", [_vm._v("请选择您要进入的案例公司：")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.companyList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { active: index === _vm.curId },
                    on: {
                      click: function($event) {
                        return _vm.tabClick(item, index)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "taxation_title" }, [
      _c("h2", [_vm._v("智能财税中级1.0")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bab00c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bab00c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/components/intermediateOne.vue
// module id = null
// module chunks = 